import {Strings} from 'Strings';
import directives from './module';

class UserAvatar {
    private static ConversionUrl = `https://conv.animatron${options.isProduction ? '' : '-test'}.com`;
    private static avatars = require.context('../../images/avatars', true);

    user: anm.User;
    size: number;
    url: string;

    constructor(private $scope: ng.IScope,
                private $element: ng.IAugmentedJQuery,
                private $filter: ng.IFilterService,
                private $attrs: any) {

        const avatarCode = () => {
            const code = Array.prototype.map.call(this.user.username, (c: string) => c.charCodeAt(0))
                    .reduce((a: number, b: number) =>  a + b) % 13;
            return require(`../../images/avatars/male/${Math.max(1, code)}.svg`);
        };

        const encodeUsername = $filter('encodeUsername');
        const imgElement = <HTMLImageElement>$element[0].getElementsByTagName('img')[0];
        const setDefaultAvatar = () => {
            imgElement.src     = avatarCode();
            imgElement.onerror = undefined;
        };

        const getSizedUrl = (url: string) => {
            if (_.isNumber(this.size)) {
                if (/google/.test(url)) {
                    return url + '?sz=' + this.size;
                } else if (/facebook/.test(url)) {
                    return url.replace(/\?type=.*$/, '') + `?width=${this.size}&height=${this.size}`;
                } else if (/gravatar/.test(url)) {
                    return url + '?s=' + this.size;
                } else if (/animatron/.test(url) && !/svg/.test(url)) {
                    return`${UserAvatar.ConversionUrl}?u=${url}&p=r${this.size}:${this.size}:0&o=jpg`;
                }
            }
            return url;
        };

        const matchAvatarApi = (url: string) => {
            const match = url.match(/profile\/avatar\/(.*)/);
            return match && match.length > 0 ?
                url.replace(match[1], encodeUsername(match[1])) : url;
        };

        const setUrl = (url: string) => {
            url = matchAvatarApi(url);
            if (Strings.isBlank(url)) {
                setDefaultAvatar();
            } else {
                imgElement.onerror = () => setDefaultAvatar();
                imgElement.src = getSizedUrl(url);
            }
        };

        const watchObject = this.url ? 'url' : 'user.avatar';
        const watcher = $scope.$watch('$ctrl.' + watchObject, (url: string) => {
            if ((imgElement && !_.isUndefined(url)) || (this.user && !this.user.avatar)) {
                setUrl(url || '');
                const enableWatch = angular.isString($attrs.watch);
                if (!enableWatch) {
                    watcher();
                    setTimeout(() => $scope.$destroy());
                }
            }
        });

    }
}

directives.component('userAvatar', {
        bindings: {
            url: '<',
            size: '<',
            user: '<'
        },
        controller: UserAvatar,
        template: '<img width="{{::$ctrl.size}}" height="{{::$ctrl.size}}" alt="{{::$ctrl.user.displayName}}"/>'
    }
);




// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/userAvatarDirective.ts